import {
	GET_HOME_DASHBOARD_STATS,
	GET_HOME_DASHBOARD_STATS_FAIL,
	GET_HOME_DASHBOARD_STATS_SUCCESS,
	HOME_DOWNLOAD,
	SHOW_HOME_DOWNLOAD_SUCCESS_ALERT,
	INITIAL_HOME_DASHBOARD_VISIT
} from '../../constants/homeDashboard/homeDashboardConstants';

export const homeDashboardStatsReducer = (
	state = { 
		homeDashStats: {}, 
		homeDashStatsError: {}, 
		showDownloadHome:false,
		showHomeDownloadSuccessAlert:false,
		initialHomeVisit: false
	},
	action
) => {
	switch (action.type) {
		case GET_HOME_DASHBOARD_STATS:
			return{
				...state,
				loading:action.payload
			}
		case GET_HOME_DASHBOARD_STATS_SUCCESS:
			return {
				...state,
				homeDashStats: action.payload,
				loading:false
			};
		case GET_HOME_DASHBOARD_STATS_FAIL:
			return {
				...state,
				homeDashStatsError: action.payload,
				loading:false
			};
		case HOME_DOWNLOAD: 
				return {
					...state,
					showDownloadHome: action.payload
				};
		case SHOW_HOME_DOWNLOAD_SUCCESS_ALERT:
			return {
				...state,
				showHomeDownloadSuccessAlert: action.payload
			};
		case INITIAL_HOME_DASHBOARD_VISIT : {
			return {
				...state,
				initialHomeVisit: action.payload
			};
		}

		default:
			return state;
	}
};
